import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, useTheme, Box, Typography } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useLang } from '../../contexts/langContext';

function LanguageToggler() {
  const { lang, setLang } = useLang();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (selectedLang: 'en' | 'zh-CN') => {
    setLang(selectedLang);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-label="language selector"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.5)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.95)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        }}
      >
        <LanguageIcon
          sx={{
            fontSize: '1.25rem',
            color: theme => theme.palette.primary.main,
          }}
        />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 4,
          sx: {
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(8px)',
            borderRadius: 2,
            border: '1px solid rgba(255, 255, 255, 0.5)',
            minWidth: 120,
            overflow: 'visible',
            mt: 1.5,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'rgba(255, 255, 255, 0.95)',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
              borderLeft: '1px solid rgba(255, 255, 255, 0.5)',
              borderTop: '1px solid rgba(255, 255, 255, 0.5)',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem 
          onClick={() => handleLanguageSelect('en')}
          selected={lang === 'en'}
          sx={{
            fontSize: '0.875rem',
            py: 1,
            px: 2,
            '&.Mui-selected': {
              bgcolor: 'rgba(0, 0, 0, 0.03)',
              color: theme => theme.palette.primary.main,
              fontWeight: 600,
            },
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.06)',
            },
          }}
        >
          <Typography variant="body2">English</Typography>
        </MenuItem>
        <MenuItem 
          onClick={() => handleLanguageSelect('zh-CN')}
          selected={lang === 'zh-CN'}
          sx={{
            fontSize: '0.875rem',
            py: 1,
            px: 2,
            '&.Mui-selected': {
              bgcolor: 'rgba(0, 0, 0, 0.03)',
              color: theme => theme.palette.primary.main,
              fontWeight: 600,
            },
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.06)',
            },
          }}
        >
          <Typography variant="body2">中文</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default LanguageToggler; 